import React from 'react';

import {
  autocompleteListItemClassName,
  autocompleteListItemStyle
} from 'helpers/classNameStyles';
import Autocomplete from 'components/clarity-ui/inputs/autocomplete';
import Button from 'components/clarity-ui/inputs/button';
import Divider from 'components/clarity-ui/components/divider';
import InputField from 'components/clarity-ui/inputs/inputField/inputField';
import SectionHeader from 'components/clarity-ui/components/sectionHeader';
import WeightedLabelsTable from './weightedLabelsTable.component';
import PageNotification from 'components/clarity-ui/components/pageNotification';
import _ from 'lodash';

class AttachedLabelsComponent extends React.Component {

  renderLabelsAutocomplete () {
    return (
      <Autocomplete
        inputProps={{className:'InputField-input'}, {placeholder:'Type a Label name'}}
        onChange={_.throttle(this.props.handleLabelsAutocompleteOnChange, 1000)}
        onSelect={this.props.handleLabelsAutocompleteSelect}
        items={this.props.filteredLabels}
        value={this.props.labelAutocompleteInputValue}
        getItemValue={(label) => label.name}
        shouldItemRender={() => {return true}}
        sortItems={() => {return true}}
        renderItem={(label, isHighlighted, styles) => (
          <li
            className={autocompleteListItemClassName(isHighlighted)}
            style={autocompleteListItemStyle(isHighlighted, styles)}
            key={label.id}
          >{label.name}</li>
        )}
      />
    );
  }

  getSaveButtonAdditionalProps (clfTarget) {
    let additionalProps = {};
    const hasLabelsToSave = _.some(clfTarget.weightedClfTargets, (label) => {return _.has(label, 'action')});
    const hasErrors = _.some(clfTarget.weightedClfTargets, (label) => {return _.has(label, 'error')});
    if (!hasLabelsToSave || hasErrors) {
      additionalProps = {disabled: true};
    }
    return additionalProps;
  }

  getWeightInputAdditionalProps (labelToAdd) {
    let additionalProps = {};
    if (_.isEmpty(labelToAdd)) {
      additionalProps = {value: ''};
    }
    return additionalProps;
  }

  getAddButtonAdditionalProps (labelToAdd, clfTargetId) {
    let additionalProps = {};
    const isInvalid = !labelToAdd.labelItem || !labelToAdd.labelWeight;
    const hasErrors = !!labelToAdd.error ? labelToAdd.error : false;
    if (isInvalid || hasErrors || !clfTargetId) {
      additionalProps = {disabled: true};
    }
    return additionalProps;
  }

  renderPageNotification (pageNotification) {
    return (
      <PageNotification type={pageNotification.type}>
        { pageNotification.msg }
      </PageNotification>
    );
  }

  render () {
    const { clfTarget, labelToAdd, handleSaveOnClick, handleAddLabelWeightOnChange,
      handleAddButtonOnClick, handleRemoveWeightedLabelsOnClick, handleWeightInputOnChange,
      pageNotification } = this.props;
    return (
      <div>
        <SectionHeader>
          Attached Labels
        </SectionHeader>
        <div className="BreakLine">
          {
            pageNotification.show && pageNotification.target === 'attachedLabels'
            ? this.renderPageNotification(pageNotification)
            : null
          }
        </div>
        <div className="BreakLine">
          <WeightedLabelsTable
            clfTarget={clfTarget}
            handleRemoveWeightedLabelsOnClick={handleRemoveWeightedLabelsOnClick}
            handleWeightInputOnChange={handleWeightInputOnChange}
          />
        </div>
        <Divider />
        <div>
          <div className=" Grid-cell--6of12">
            {this.renderLabelsAutocomplete()}
          </div>
          <div className="elementPaddingLeft Grid-cell--2of12">
            <InputField {...this.getWeightInputAdditionalProps(labelToAdd)} errorMsg={labelToAdd.error} onChange={handleAddLabelWeightOnChange} placeholder="Weight"/>
          </div>
          <div className="Grid-cell--4of12 floatRightAlign">
            <Button {...this.getAddButtonAdditionalProps(labelToAdd, clfTarget.id)} elementType="button" onClick={handleAddButtonOnClick} secondary>Add</Button>
          </div>
        </div>
        <Divider />
        <div className="Grid-cell--10of12">
        </div>
        <div className="Grid-cell--2of12 floatRightAlign">
          <Button {...this.getSaveButtonAdditionalProps(clfTarget)} elementType="button" onClick={handleSaveOnClick}>Save</Button>
        </div>
      </div>
    );
  }
}

export default AttachedLabelsComponent;



// WEBPACK FOOTER //
// ./src/components/classifier/classifierTargets/attachedLabels/attachedLabels.component.jsx